module.exports = __webpack_public_path__ + "img/cb4-2-r-rr1.59df90f9.gif";